import resilienceConsultationService from '@/services/resilienceConsultationService';
import { errorHttpMessage } from '@/utils/errorDecodeUtil';

export const approveAdditionalSessionRequest = async ({ commit }, arg) => {
  const { requestId, payload = {} } = typeof arg === 'object' && arg !== null
    ? arg
    : { requestId: arg, payload: {} };
  try {
    const { data: result } = await resilienceConsultationService.approveAdditionalSessionRequest(requestId, payload);
    const { data, message, error } = result?.result || result || {};
    return { data, message, error };
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message.message,
      error_keys: error_http_message.error_keys,
      data: ex.response?.data,
      error: true
    };
  }
};

export const rejectAdditionalSessionRequest = async ({ commit }, arg) => {
  const { requestId, payload = {} } = typeof arg === 'object' && arg !== null
    ? arg
    : { requestId: arg, payload: {} };
  try {
    const { data: result } = await resilienceConsultationService.rejectAdditionalSessionRequest(requestId, payload);
    const { data, message, error } = result?.result || result || {};
    return { data, message, error };
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message.message,
      error_keys: error_http_message.error_keys,
      data: ex.response?.data,
      error: true
    };
  }
};
